<template>
  <div></div>
</template>
<script>
import swal from "sweetalert2";
export default {
  computed: {
    accpeted() {
      return Laravel.settings.cookies.affiliate;
    }
  },
  created() {
    if (!this.accpeted) {
      swal
        .fire({
          title: "Wir nutzen Cookies",
          confirmButtonColor: "#28a745",
          confirmButtonText: "Auswahl akzeptieren",
          type: "warning",
          html:
            "Bitte wählen Sie zu welchem Zweck Cookies gesetzt werden dürfen. " +
            "<br><br><small>" +
            "(Sollten nicht alle Cookies akzeptiert werden, kann es zu Einschränkungen in der Nutzung der Webseite kommen)" +
            "</small>" +
            "<br><br>" +
            "<input checked id='affiliateCookie' type='checkbox'> " +
            "<label for='affiliateCookie'>Werbung & Marketing</label>"
        })
        .then(result => {
          if (result.value) {
            this.$http
              .post(`/api/v1/cookies/accept`, {
                affiliateCookie: document.getElementById("affiliateCookie")
                  .checked
              })
              .then(() => location.reload());
          }
        });
    }
  }
};
</script>
